import { IntlShape } from 'react-intl';

import messages from '@/components/emotion-detector/messages';

export function getButtonText(detecting: boolean, formatMessage: IntlShape['formatMessage']): string {
	return detecting
		? formatMessage(messages.cameraCaptureCapturing)
		: formatMessage(messages.cameraCaptureCTA);
}
